import { AudioHighlightChip } from '@modules/feedback/components/AudioType/AudioFeedbackPlayer/AudioHighlightChip';
import { AudioHighlightMetadata } from '@modules/feedback/components/AudioType/types';
import {
  getBookmarkStyles,
  getHighlightTooltipComponentProps,
  getLabelFromHighlight,
} from '@modules/feedback/components/AudioType/utils';
import { Box, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import { FeedbackLabel } from 'v2/core/entities/feedback';

interface AudioHighlightBookmarkProps {
  highlight: AudioHighlightMetadata;
  highlightMetadata: AudioHighlightMetadata[];
  duration: number;
  onClick: (startTime: number) => void;
  isDisabled?: boolean;
  selectedLabels: FeedbackLabel[];
}

export const AudioHighlightBookmark = ({
  highlight,
  highlightMetadata,
  duration,
  onClick,
  isDisabled = false,
  selectedLabels,
}: AudioHighlightBookmarkProps) => {
  const theme = useTheme();

  const highlightMatches = highlightMetadata.filter((highlightMatch) => {
    const hasSameTime =
      highlightMatch.startTime === highlight.startTime &&
      highlightMatch.endTime === highlight.endTime;
    return hasSameTime;
  });

  return (
    <Tooltip
      arrow
      title={
        <Stack spacing={1} p={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2">Highlight for</Typography>
            <Stack spacing={1}>
              {highlightMatches.map((highlightMatch, index) => (
                <AudioHighlightChip
                  key={`${highlightMatch.labelID}_${index}`}
                  highlight={highlightMatch}
                  label={getLabelFromHighlight(selectedLabels, highlightMatch)}
                />
              ))}
            </Stack>
          </Stack>
        </Stack>
      }
      placement="top"
      componentsProps={getHighlightTooltipComponentProps(400)}
    >
      <Box
        onClick={() => {
          if (isDisabled) {
            return;
          }
          onClick(highlight.startTime);
        }}
        sx={{
          ...getBookmarkStyles({
            theme,
            highlight,
            duration,
            zIndex: 2,
            isDisabled,
            backgroundColor: theme.palette.secondary.main,
          }),
        }}
      />
    </Tooltip>
  );
};
